import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const contactInfosReducer = (state = initialState.contactInfos, action) => {
  switch (action.type) {
    case types.LOAD_CONTACT_INFOS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_CONTACT_INFOS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_CONTACT_INFOS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_CONTACT_INFOS_SUCCEEDED: {
      //set loaded false in order to retrieve the data again from server
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: contactInfosReducer
});
